import { Directive, DoCheck, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';

@Directive({
  selector: '[appEzInput]',
})
export class EzInputDirective implements DoCheck {
  elementRef: ElementRef<any> = inject(ElementRef);
  control: NgControl = inject(NgControl);

  private prevValue: unknown;
  private _doCheckSubj$: Subject<unknown> = new Subject<unknown>();
  doCheckSubj$: Observable<unknown> = this._doCheckSubj$.asObservable();

  @Output() focused: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostListener('focusin')
  onFocusIn(): void {
    this.focused.emit(true);
  }

  @HostListener('focusout')
  onFocusOut(): void {
    this.focused.emit(false);
  }

  ngDoCheck(): void {
    if(this.prevValue !== this.elementRef.nativeElement.value) {
      this.prevValue = this.elementRef.nativeElement.value;
      this._doCheckSubj$.next(null);
    }
  }
}
